import { invert, snakeCase } from "lodash-es";
//#region src/SexAndGender/constants.ts
/**
* Sex Assigned at Birth values that are sent to and received from the server.
*/
var SexAssignedAtBirth = /* @__PURE__ */ function(SexAssignedAtBirth) {
	SexAssignedAtBirth["FEMALE"] = "F";
	SexAssignedAtBirth["MALE"] = "M";
	return SexAssignedAtBirth;
}({});
/**
* Gender Identity values that are sent to and received from the server.
* They currently match the display values, but are not guaranteed to match in the future.
*/
var GenderIdentity = /* @__PURE__ */ function(GenderIdentity) {
	GenderIdentity["WOMAN"] = "Female/woman";
	GenderIdentity["MAN"] = "Male/man";
	GenderIdentity["TRANS_WOMAN"] = "Transgender female/woman";
	GenderIdentity["TRANS_MAN"] = "Transgender male/man";
	GenderIdentity["NONBINARY_GENDERQUEER"] = "Nonbinary, genderqueer, or not exclusively female or male";
	GenderIdentity["ANOTHER_GENDER"] = "Another gender";
	GenderIdentity["DO_NOT_KNOW"] = "Don't know";
	GenderIdentity["PREFER_NOT_TO_SAY"] = "Prefer not to say";
	return GenderIdentity;
}({});
/**
* This will soon be deprecated in favor of the new GenderIdentity enum.
*/
var GENDER_IDENTITIES = /* @__PURE__ */ function(GENDER_IDENTITIES) {
	GENDER_IDENTITIES["FEMALE"] = "F";
	GENDER_IDENTITIES["MALE"] = "M";
	GENDER_IDENTITIES["NON_BINARY"] = "non-binary";
	GENDER_IDENTITIES["SELF_DESCRIBED"] = "self-described";
	GENDER_IDENTITIES["PREFER_NOT_TO_RESPOND"] = "prefer not to respond";
	GENDER_IDENTITIES["TRANS_MALE"] = "trans-male";
	GENDER_IDENTITIES["TRANS_FEMALE"] = "trans-female";
	GENDER_IDENTITIES["NOT_LISTED"] = "not-listed";
	return GENDER_IDENTITIES;
}({});
var djangoValuesByGenderIdentity = {
	["Female/woman"]: "F",
	["Male/man"]: "M",
	["Transgender female/woman"]: "trans-female",
	["Transgender male/man"]: "trans-male",
	["Nonbinary, genderqueer, or not exclusively female or male"]: "non-binary",
	["Another gender"]: "self-described",
	["Don't know"]: "dont-know",
	["Prefer not to say"]: "prefer not to respond"
};
var genderIdentityByDjangoValues = invert(djangoValuesByGenderIdentity);
var GenderIdentityDataSharingRequirement = /* @__PURE__ */ function(GenderIdentityDataSharingRequirement) {
	GenderIdentityDataSharingRequirement[GenderIdentityDataSharingRequirement["SENT_TO_EXTERNAL_EMR"] = 0] = "SENT_TO_EXTERNAL_EMR";
	GenderIdentityDataSharingRequirement[GenderIdentityDataSharingRequirement["SENT_TO_STATE_FEDERAL_DASHBOARD"] = 1] = "SENT_TO_STATE_FEDERAL_DASHBOARD";
	GenderIdentityDataSharingRequirement[GenderIdentityDataSharingRequirement["SHARED_WITH_CLINICIAN_WHEN_APPROPRIATE"] = 2] = "SHARED_WITH_CLINICIAN_WHEN_APPROPRIATE";
	return GenderIdentityDataSharingRequirement;
}({});
var SEX_ASSIGNED_AT_BIRTH_FIELD_NAME = "sex";
var GENDER_IDENTITY_FIELD_NAME = "genderIdentity";
var ANOTHER_GENDER_FIELD_NAME = "selfDescribedGenderIdentity";
var SEXUAL_ORIENTATION_FIELD_NAME = "sexualOrientation";
var NOT_LISTED_FIELD_NAME = "selfDescribedSexualOrientation";
var GENDER_IDENTITY_CAMEL_CASE_FIELD_NAMES = {
	genderIdentityFieldName: GENDER_IDENTITY_FIELD_NAME,
	anotherGenderFieldName: ANOTHER_GENDER_FIELD_NAME
};
/**
* Sexual Orientation Identity values that are sent to and received from the server.
* They currently match the display values, but are not guaranteed to match in the future.
*/
var SexualOrientationIdentity = /* @__PURE__ */ function(SexualOrientationIdentity) {
	SexualOrientationIdentity["LESBIAN_OR_GAY"] = "Lesbian or gay";
	SexualOrientationIdentity["STRAIGHT_OR_HETEROSEXUAL"] = "Straight or heterosexual";
	SexualOrientationIdentity["BISEXUAL"] = "Bisexual";
	SexualOrientationIdentity["QUEER"] = "Queer";
	SexualOrientationIdentity["ASEXUAL"] = "Asexual";
	SexualOrientationIdentity["PANSEXUAL"] = "Pansexual";
	SexualOrientationIdentity["DO_NOT_KNOW"] = "Don't know";
	SexualOrientationIdentity["PREFER_NOT_TO_SAY"] = "Prefer not to say";
	SexualOrientationIdentity["NOT_LISTED"] = "Not Listed";
	return SexualOrientationIdentity;
}({});
/**
* Default field names for Sex Assigned at Birth, Gender Identity, and Another Gender
* fields. Used in Sex and Gender utilities and UI components.
*/
var SEX_AND_GENDER_IDENTITY_CAMEL_CASE_FIELD_NAMES = {
	sexAssignedAtBirthFieldName: "sex",
	...GENDER_IDENTITY_CAMEL_CASE_FIELD_NAMES
};
var GENDER_IDENTITY_SNAKE_CASE_FIELD_NAMES = {
	genderIdentityFieldName: snakeCase(GENDER_IDENTITY_FIELD_NAME),
	anotherGenderFieldName: snakeCase(ANOTHER_GENDER_FIELD_NAME)
};
var SEXUAL_ORIENTATION_CAMEL_CASE_FIELD_NAMES = {
	sexualOrientationFieldName: SEXUAL_ORIENTATION_FIELD_NAME,
	notListedFieldName: NOT_LISTED_FIELD_NAME
};
//#endregion
export { GENDER_IDENTITY_SNAKE_CASE_FIELD_NAMES as a, NOT_LISTED_FIELD_NAME as c, SEX_AND_GENDER_IDENTITY_CAMEL_CASE_FIELD_NAMES as d, SEX_ASSIGNED_AT_BIRTH_FIELD_NAME as f, genderIdentityByDjangoValues as g, djangoValuesByGenderIdentity as h, GENDER_IDENTITY_FIELD_NAME as i, SEXUAL_ORIENTATION_CAMEL_CASE_FIELD_NAMES as l, SexualOrientationIdentity as m, GENDER_IDENTITIES as n, GenderIdentity as o, SexAssignedAtBirth as p, GENDER_IDENTITY_CAMEL_CASE_FIELD_NAMES as r, GenderIdentityDataSharingRequirement as s, ANOTHER_GENDER_FIELD_NAME as t, SEXUAL_ORIENTATION_FIELD_NAME as u };

//# sourceMappingURL=SexAndGender-BA9IAYHx.js.map